import type { ISettingsBookkeepingGetItemPayload } from '@modules/general-settings/submodules/bookkeeping/types';
import { isNumber, isValidInterface } from '@utils/guards';

export function isSettingsBookkeepingGetItemPayload(argument: unknown): argument is ISettingsBookkeepingGetItemPayload {
  return isValidInterface<ISettingsBookkeepingGetItemPayload>(argument, { id: isNumber, merchantId: isNumber });
}
